// Mandate Report  Pending
import React, { useEffect, useState } from 'react';
import { models } from 'powerbi-client';
import { PowerBIEmbed } from 'powerbi-client-react';
import './powerbi.css';
import SnackBar from '../../General/SnackBar';
import BackdropLoader from '../../General/Loader';
import { FetchUserAccessLocation } from 'API/PowerBI/api';
import { CheckLeadership } from './CheckLeadership';

function ActivityReport() {
  const [accessToken, setAccessToken] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [AlertMessage, setAlertMessage] = useState('');
  const [OpenAlert, setOpenAlert] = useState(false);
  const [AlertType, setAlertType] = useState(false);

  const [LocationDetails, setLocationDetails] = useState(false);

  const handleAlertOpen = (message, type) => {
    setAlertMessage(message);
    setAlertType(type);
    setOpenAlert(true);
  };

  const handleAlertClose = () => {
    setOpenAlert(false);
  };

  useEffect(() => {
    FetchUserAccessLocation(setIsLoading, setLocationDetails, handleAlertOpen);
  }, []);

  const [reportConfig, setReportConfig] = useState({
    tokenType: models.TokenType.Embed,
    visualName: 'powerbi',
    height: 100,
    width: 100,
    accessToken: accessToken,
    type: 'report',
    id: 'c9f36504-796e-4f2b-8a27-82637790519a',
    embedUrl:
      'https://app.powerbi.com/reportEmbed?reportId=c9f36504-796e-4f2b-8a27-82637790519a&groupId=5f2b7be5-fa45-4627-a744-96acb75a9c5e&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUlORElBLVdFU1QtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQiLCJlbWJlZEZlYXR1cmVzIjp7InVzYWdlTWV0cmljc1ZOZXh0Ijp0cnVlfX0%3d',
    settings: {
      panes: {
        filters: {
          expanded: false,
          visible: false
        },
        pageNavigation: {
          visible: false
        }
      },
    },
    filters: [
      {
        $schema: 'http://powerbi.com/product/schema#basic',
        target: { table: 'RAW_CSP_DUMP', column: 'Stateid' },
        operator: 'In',
        values: LocationDetails && Array.isArray(LocationDetails.stateids) ? LocationDetails.stateids : [LocationDetails.stateids],
        filterType: 1,
        displaySettings: {
          isLockedInViewMode: true,
          isHiddenInViewMode: true,
          displayName: 'State Filter'
        }
      },
      {
        $schema: 'http://powerbi.com/product/schema#basic',
        target: { table: 'RAW_CSP_DUMP', column: 'DistictID' },
        operator: 'In',
        values: LocationDetails && Array.isArray(LocationDetails.districtids) ? LocationDetails.districtids : [LocationDetails.districtids],
        filterType: 1,
        displaySettings: {
          isLockedInViewMode: true,
          isHiddenInViewMode: true,
          displayName: 'Distict Filter'
        }
      }
    ],
    pageName: 'f6a02e6487563211d4ac'
  });

  useEffect(() => {
    // Fetch access token
    const fetchAccessToken = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BANKVERIFY_URL}powerbi-dashboard-access-token-api/accesstoken`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        });

        if (response.status === 403) {
          throw new Error('CORS error: Access denied. Please check server configuration.');
        }
        if (!response.ok) {
          throw new Error('Failed to fetch access token');
        }

        const data = await response.json();
        setAccessToken(data.token);

        // Update reportConfig with the new access token
        setReportConfig((prevConfig) => ({
          ...prevConfig,
          accessToken: data.token
        }));
      } catch (error) {
        console.error('Error fetching access token:', error);
      }
    };

    fetchAccessToken();
  }, []);

  console.log(LocationDetails, reportConfig);

  return (
    <div
      className="tab-activation"
      style={{ height: '100%', width: '100%', display: 'flex', alignItems: 'stretch', justifyContent: 'stretch' }}
    >
      <SnackBar open={OpenAlert} type={AlertType} message={AlertMessage} handleClose={handleAlertClose} />
      <BackdropLoader open={isLoading} />
      {accessToken && LocationDetails &&
      CheckLeadership()?
      <PowerBIEmbed embedConfig={{
        tokenType: models.TokenType.Embed,
        visualName: 'powerbi',
        height: 100,
        width: 100,
        accessToken: accessToken,
        type: 'report',
        id: 'c9f36504-796e-4f2b-8a27-82637790519a',
        embedUrl:
          'https://app.powerbi.com/reportEmbed?reportId=c9f36504-796e-4f2b-8a27-82637790519a&groupId=5f2b7be5-fa45-4627-a744-96acb75a9c5e&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUlORElBLVdFU1QtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQiLCJlbWJlZEZlYXR1cmVzIjp7InVzYWdlTWV0cmljc1ZOZXh0Ijp0cnVlfX0%3d',
        settings: {
          panes: {
            filters: {
              expanded: false,
              visible: false
            },
            pageNavigation: {
              visible: false
            }
          },
        },
        
        pageName: 'e251f4fe7b9b699bde03'
      }} cssClassName="powerbi-div" />
      :
       <PowerBIEmbed embedConfig={{
        tokenType: models.TokenType.Embed,
        visualName: 'powerbi',
        height: 100,
        width: 100,
        accessToken: accessToken,
        type: 'report',
        id: 'c9f36504-796e-4f2b-8a27-82637790519a',
        embedUrl:
          'https://app.powerbi.com/reportEmbed?reportId=c9f36504-796e-4f2b-8a27-82637790519a&groupId=5f2b7be5-fa45-4627-a744-96acb75a9c5e&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUlORElBLVdFU1QtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQiLCJlbWJlZEZlYXR1cmVzIjp7InVzYWdlTWV0cmljc1ZOZXh0Ijp0cnVlfX0%3d',
        settings: {
          panes: {
            filters: {
              expanded: false,
              visible: false
            },
            pageNavigation: {
              visible: false
            }
          },
        },
        filters: [
          {
            $schema: 'http://powerbi.com/product/schema#basic',
            target: { table: 'RAW_CSP_DUMP', column: 'Stateid' },
            operator: 'In',
            values: LocationDetails && Array.isArray(LocationDetails.stateids) ? LocationDetails.stateids : [LocationDetails.stateids],
            filterType: 1,
            displaySettings: {
              isLockedInViewMode: true,
              isHiddenInViewMode: true,
              displayName: 'State Filter'
            }
          },
          {
            $schema: 'http://powerbi.com/product/schema#basic',
            target: { table: 'RAW_CSP_DUMP', column: 'DistictID' },
            operator: 'In',
            values: LocationDetails && Array.isArray(LocationDetails.districtids) ? LocationDetails.districtids : [LocationDetails.districtids],
            filterType: 1,
            displaySettings: {
              isLockedInViewMode: true,
              isHiddenInViewMode: true,
              displayName: 'Distict Filter'
            }
          }
        ],
        pageName: 'e251f4fe7b9b699bde03'
      }} cssClassName="powerbi-div" />}
    </div>
  );
}
export default ActivityReport;
